import React from 'react';
import CardsListingCard from './shared';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CardsListingComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CardsListing" />;
  }
  const { items } = props?.fields;
  const { imageAlignment, Styles } = props.params;

  return (
    <div
      className={clsx(
        'content',
        imageAlignment?.toLowerCase().replace(/\s/g, '-'),
        'add-margins',
        Styles
      )}
    >
      {items.map((item, index) => (
        <CardsListingCard data={item} key={index} />
      ))}
    </div>
  );
};

export default CardsListingComponent;
